import React from 'react'
import { CertificateDocumentStatus } from '../../../../../../enums/CertificateDocumentStatus'
import classes from './CertificateDetailsRPStatusIcon.module.scss'
import { AddAttachmentsRPUtils } from '../../../add-new-certificate/rp-library/shared/utils/AddAttachmentsRPUtils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IAddAttachmentsRPTestReportModel } from '../../../add-new-certificate/rp-library/shared/interfaces/IAddAttachmentsRPTestReportModel'
import { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core'
import {
  faCircleCheck,
  faExclamationCircle,
  faInfoCircle,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons'
import clsx from 'clsx'
import { IAddAttachmentsRPTestSupportingDocumentModel } from '../../../add-new-certificate/rp-library/shared/interfaces/IAddAttachmentsRPTestSupportingDocumentModel'

interface ICertificateDetailsRPStatusIconProps {
  isLinkInProcess: boolean
  rpAttachmentFile: IAddAttachmentsRPTestReportModel | IAddAttachmentsRPTestSupportingDocumentModel
  size?: SizeProp
  className?: string
}

const CertificateDetailsRPStatusIcon = (props: ICertificateDetailsRPStatusIconProps) => {
  const renderStatusIcon = (status: CertificateDocumentStatus | null) => {
    switch (status) {
      case CertificateDocumentStatus.UploadToEcmInProgress:
      case CertificateDocumentStatus.TestReportDuplicateLinkToEcmInProgress:
      case CertificateDocumentStatus.NotYetUploaded:
      case CertificateDocumentStatus.RetryUploadToEcmTicInProgress:
      case CertificateDocumentStatus.UnlinkingInProgress:
        return classes['uploading-icon']
      case CertificateDocumentStatus.LinkedToWbAndEcmTic:
        return classes['legend-icon-1']
      case CertificateDocumentStatus.SavedInEcmTic:
        return classes['legend-icon-2']
      case CertificateDocumentStatus.ReadyToLinkToWbAndEcmTic:
      case CertificateDocumentStatus.TestReportDuplicate:
      case CertificateDocumentStatus.UploadToEcmFailed:
        return classes['legend-icon-3']
      case CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed:
      case CertificateDocumentStatus.UploadToBlobFailed:
        return classes['legend-icon-4']
    }
  }

  const renderStatusText = AddAttachmentsRPUtils.getDocumentStatusText(
    props.rpAttachmentFile.status
  )
  const getFileIcon = (
    itemFile: IAddAttachmentsRPTestReportModel | IAddAttachmentsRPTestSupportingDocumentModel
  ): IconDefinition => {
    if (AddAttachmentsRPUtils.isStatusUploading(itemFile.status) || props.isLinkInProcess)
      return faSpinner

    if (itemFile.status === CertificateDocumentStatus.UploadToEcmFailed) return faExclamationCircle

    if (itemFile.status === CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed)
      return faInfoCircle

    if (itemFile.status === CertificateDocumentStatus.UploadToBlobFailed) return faExclamationCircle

    return faCircleCheck
  }

  return (
    <div
      aria-valuetext={renderStatusText}
      aria-label="status-indicator"
      className={`${classes['status-indicator-container']} ${props.className}`}
    >
      <FontAwesomeIcon
        title={renderStatusText}
        icon={getFileIcon(props.rpAttachmentFile)}
        size={props.size ?? 'xs'}
        spin={
          AddAttachmentsRPUtils.isStatusUploading(props.rpAttachmentFile.status) ||
          props.isLinkInProcess
        }
        className={clsx(
          classes['icons'],
          classes['icons-ml'],
          renderStatusIcon(props.rpAttachmentFile.status)
        )}
      />
    </div>
  )
}

export default CertificateDetailsRPStatusIcon
